import productRecommendationInputData from './inputData/product-recommendation';
import { TemplateItem } from './types';
import { convertDraftParamsToLeadForm } from '../convertDraftParamsToLeadForm';

const previewInput = {
  workspaceId: 'preview-workspace',
  formId: 'preview-form',
  collectionId: 'preview-collection'
};

const template: TemplateItem = {
  id: 'product-recommendation-quiz',
  title: 'Product Recommendation Quiz',
  description: 'Give shoppers a tailored experience with this product recommendation quiz designed to guide them to the perfect choice.',
  image: '/images/templates/product-recommendation-quiz.png',
  tags: ['sales', 'make-sales'],
  popular: true,
  inputData: productRecommendationInputData,
  formPreview: convertDraftParamsToLeadForm(
    productRecommendationInputData(),
    previewInput
  ),
}

export default template;

